import { Routes } from '@angular/router';
import { FailedComponent } from './failed/failed.component';
import { ApViewerComponent } from './ap-viewer/ap-viewer.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    // AP Document Viewer is the landing page. MsalGuard forces Microsoft sign-in
    // (redirect flow) on app open when the user isn't already authenticated.
    path: '',
    component: ApViewerComponent,
    canActivate: [MsalGuard],
  },
  {
    // MSAL login-failure landing (referenced by MSALGuardConfig.loginFailedRoute).
    path: 'login-failed',
    component: FailedComponent,
  },
];
